import { reports, dateRanges } from "../../modules/reviews/ReviewFilterStore";
import { bindShallow } from '../../uiMigration/bindAngularWithMobx';
import reviewFiltersStore from "../../modules/reviews/ReviewFilterStore";
import { toJS } from "mobx";
import { bindReviewFiltersAndSelectedLocationToAngular } from "./filterBindingUtils";

let moment = require('moment');

/*TODO: Tons of code duplication between this and the LocationComparisonReportController.  Put shared logic in a common file.*/

angular.module('clientDashboardApp').controller("StoreComparisonReportController",
  function ($scope, $sce, $q, reviewService, $location, $log, reactContainer) {

    $scope.processStack = []
    var previousFilter = {}
    var expandedGroups = []
    $scope.providers = [];

    initializeForm();

    function initializeForm() {
      $scope.reportSearchConfig = {};
      bindReviewFiltersAndSelectedLocationToAngular($scope, $scope.reportSearchConfig);
    }

    $scope.$watch("reportSearchConfig", (newConfig, oldConfig) => {
      if (!!newConfig && !angular.equals(newConfig.report, !!oldConfig ? oldConfig.report : {}) || !angular.equals(newConfig, oldConfig)) {
        if (!!newConfig.report && newConfig.report.reportType === 'storeComparison') {
          $scope.changeInGroup = (newConfig.groupId != oldConfig.groupId);
        }
        searchFormToStateChange()
      }
    }, true);

    function searchFormToStateChange() {
      if ($scope.showGroups == true) {
        executeSearch();
      }
    }

    function isDuplicateSearch(filter) {
      return angular.equals(previousFilter, filter)
    }

    function executeSearch() {
      if (!isDateRangeValid()) {
        return
      }
      var filter = createSearchFilter();

      if (!isDuplicateSearch(filter)) {
        previousFilter = filter
        $scope.processStack.push("searching")
        reviewService.generateComparisonReport(filter).then(response => {
          if ($scope.changeInGroup) {
            collapseAllGroups()
          }
          processGroupSearchResults(response, filter)
        });
      }
    }

    function processGroupSearchResults(response, filters) {
      let childPromises = []

      if (response.childReportsLoaded) {
        if (! $scope.isExpanded(response.id)) {
          expandedGroups.push(response.id)
        }

        let groups = _.filter(response.childComparisonReports, r => r.reportType === "Group")
        _.forEach(groups, group => {

          if(group.childReportsLoaded) {
            if (! $scope.isExpanded(group.id)) {
              expandedGroups.push(group.id)
            }
          }
          else if ($scope.isExpanded(group.id)) {
            childPromises.push(loadLocationsForGroup(group))
          }
        })
      }

      $q.all(childPromises).then (() =>{
        $scope.orgSummary = response

        $scope.reportData = _.filter(response.childComparisonReports, r => r.reportType === "Group")
        $scope.ungroupedLocationsData = _.filter(response.childComparisonReports, r => r.reportType === "Location")
        $scope.processStack.pop()

        $scope.comparisonExportToken = {
          'export': () => {
            let exportFilters = angular.copy(filters);
            return reviewService.exportComparisonData(exportFilters);
          },
          totalResults: 0
        }
      })
    }

    function loadLocationsForGroup(group) {
      var filter = createSearchFilter();
      return reviewService.locationsComparisonReport(group.id, filter).then(response => {
        group.childComparisonReports = response
        group.childReportsLoaded = true
      });
    }

    function isDateRangeValid() {
      return ($scope.reportSearchConfig.startDate && $scope.reportSearchConfig.endDate);
    }

    function createSearchFilter() {
      var filter = {};
      filter.groupId = reviewFiltersStore.state.groupId;
      filter.compareToPreviousPeriod = $scope.reportSearchConfig.compareToPreviousPeriod;
      filter.range = $scope.reportSearchConfig.range;

      const selected = dateRanges.find(range =>
        range.to.diff($scope.reportSearchConfig.endDate, "days") === 0 &&
        range.from.diff($scope.reportSearchConfig.startDate, "days") === 0
      );

      filter.reportRange = !!selected && selected.id !== "LastDay" ? selected.id : "SpecificDates";
      
      if ($scope.reportSearchConfig.startDate && filter.reportRange !== "AllTime") {
        filter.startDate = moment($scope.reportSearchConfig.startDate).format("YYYY-MM-DD")
      }

      if ($scope.reportSearchConfig.endDate && filter.reportRange !== "AllTime") {
        filter.endDate = moment($scope.reportSearchConfig.endDate).format("YYYY-MM-DD")
      }

      if ($scope.reportSearchConfig.providers) {
        filter.providers = $scope.reportSearchConfig.providers.join()
      }
      filter.sortField = $scope.reportSearchConfig.sortField;
      filter.sortOrder = $scope.reportSearchConfig.sortOrder;

      return filter
    }

    $scope.getReportSortIcon = function (column) {
      if ($scope.reportSearchConfig.sortField === column) {
        if ($scope.reportSearchConfig.sortOrder === 'ASC') {
          return 'fa-sort-up';
        } else {
          return 'fa-sort-down';
        }
      } else {
        return 'fa-sort';
      }
    };

    $scope.sortReportTable = function (sortColumn) {
      if ($scope.reportSearchConfig.sortField === sortColumn) {
        if ($scope.reportSearchConfig.sortOrder === 'ASC') {
          $scope.reportSearchConfig.sortOrder = 'DESC';
        } else {
          $scope.reportSearchConfig.sortOrder = 'ASC';
        }
      } else {
        $scope.reportSearchConfig.sortField = sortColumn;
        $scope.reportSearchConfig.sortOrder = 'DESC';
      }
    };

    $scope.isExpanded = function(groupId){
      return _.indexOf(expandedGroups, groupId) > -1
    }

    $scope.collapseGroup = function(group) {
      expandedGroups = _.filter(expandedGroups, (gid) => gid != group.id)
    }

    $scope.expandGroup = function(group) {
      if ($scope.isExpanded(group.id)) {
        return
      }

      if (group.childReportsLoaded) {
        collapseAllGroups()
        expandedGroups.push(group.id)
      }
      else if (!group.id.startsWith('all-')) {
        loadGroupLocations(group)
      }
    }

    $scope.formatValueAndChangePercentage = function (summary, property, showIcon) {
      const storeComparison = summary.storeComparison || {};
      if (summary && angular.isDefined(storeComparison[property])) {
        return "<span class='value-with-change'> " + storeComparison[property].toLocaleString() + " " + formatChangePercentage(summary.change[property], showIcon) + "</span>"
      }
      else {
        return "-"
      }
    }

    $scope.ratingPercentage = (report, ratingField) => {
      const storeComparison = report.storeComparison || {};
      if ($scope.reportSearchConfig.compareToPreviousPeriod) {
        return ""
      } else if (storeComparison.count && storeComparison.count > 0) {
        const percentage = storeComparison[ratingField] / storeComparison.count;

        return "<span class='value-with-change'>" + storeComparison[ratingField].toLocaleString() +
          "<span>" + Math.round(percentage*100) + "%"+ "</span></span>"
      } else {
        return "<span class='value-with-change'>" + storeComparison[ratingField].toLocaleString() + "</span>";
      }
    }

    $scope.selectAllProviders = () => {
      $scope.reportSearchConfig.providers = _.map($scope.providers, p=> p.id)
    }

    $scope.showRecommendations = () => {
      return !$scope.reportSearchConfig.providers.length || $scope.reportSearchConfig.providers.indexOf('FACEBOOK') >= 0
    }

    $scope.formatRecommendationData = (summary, showIcon) => {
      if (!summary) return "-";
      const storeComparison = summary.storeComparison || {};
      const {totalRecommended, totalNotRecommended} = storeComparison;
      if (summary && angular.isDefined(totalRecommended) && angular.isDefined(totalNotRecommended)) {
        return `
        <div class='value-with-change'><span class="far fa-thumbs-up"></span> ${totalRecommended.toLocaleString()} ${formatChangePercentage(summary.change['totalRecommended'], showIcon)} </div>
        <div class='value-with-change'><span class="far fa-thumbs-down"></span> ${totalNotRecommended.toLocaleString()} ${formatChangePercentage(summary.change['totalNotRecommended'], showIcon)} </div>`
      } else {
        return "-"
      }
    }

    function loadGroupLocations(group) {
      var filter = createSearchFilter();

      previousFilter = filter
      $scope.processStack.push("search")
      return reviewService.locationsComparisonReport(group.id, filter).then(response => {
        group.childComparisonReports = response
        group.childReportsLoaded = true
        collapseAllGroups()
        if (!$scope.isExpanded(group.id)) {
          expandedGroups.push(group.id)
        }
        $scope.processStack.pop()
      });
    }

    function collapseAllGroups() {
      expandedGroups = _.filter(expandedGroups, groupId => { return groupId.startsWith('all-')} )
    }

    function formatChangePercentage(value, showIcon) {
      if (angular.isDefined(value)) {
        var floatValue = parseFloat(value)
        var icon = ""
        var labelCssClass = ""
        if (showIcon && floatValue != 0.0) {
          labelCssClass = (floatValue > 0) ? "change-increase" : "change-decrease"
        }
        if (floatValue < 0) {
          floatValue = floatValue * -1.0
        }
        var formattedValue = (floatValue).toFixed(0)
        return $sce.trustAsHtml("<span class='" + labelCssClass + "'>" + formattedValue + "% " + "</span>")

      }
      else {
        return "";
      }
    }

    searchFormToStateChange();

  });
